/*
The list of 'custom' API's that are displayed at the end of the API list
These are entries that do not exist in the API json file (3dx_api.json)
and the contents of the details pane can be displayed as desired.

Key details:
category - The name of the category that shown as the header
description (optional) - If specified, this description will be shown next to the header category text
visible (optional) - Set to true to make this category visible, false to hide. Default is true
specs - All the sub-item specs that will be shown below the header. Key details are:
        name - The name of the sub-item that will be displayed
        id - The unique ID of this sub-item
        url - The route URL to browse to when selected
        description (optional) - If specified, will be shown as the tooltip when hovering over the sub-item
        visible (optional) - Set to true to make this sub-item visible, false to hide. Default is true
        security (optional) - Set to true to show a lock icon prefixed on the sub-item name, false to hide. Default is false
*/
export const customApis = [
  {
    category : "3DX API Usage Examples",
    id : "api_examples",
    description : "",
    visible : true,
    specs : [
      {
        name: "3DX API Examples Table of Contents",
        description : "Introduction to sample templates for 3DX API",
        visible : true,
        id : "api_sample_introduction",
        url : "/examples/toc",
        security : false
      },
      {
        name: "Product Page Example #1",
        description : "Product Page Example #1",
        visible : true,
        id : "product_page_api_example_1",
        url : "/examples/productpageexample-1",
        security : false
      },
      {
        name: "Product Page Example #2",
        description : "Product Page Example #2",
        visible : true,
        id : "product_page_api_example_2",
        url : "/examples/productpageexample-2",
        security : false
      },
      {
        name: "Preview and Download Part Number Example #3",
        description : "Preview and Download Part Number Example #3",
        visible : true,
        id : "preview_download_api_example_3",
        url : "/examples/previewdownloadexample-3",
        security : false
      },
      {
        name: "Part Number Preview Example #4",
        description : "Part Number Preview Example #4",
        visible : true,
        id : "part_number_preview_api_example_4",
        url : "/examples/partnumberpreviewexample-4",
        security : false
      },
      {
        name: "Part Number Preview Dialog Example #5",
        description : "Part Number Preview Dialog Example #5",
        visible : true,
        id : "part_number_preview_dialog_api_example_5",
        url : "/examples/partnumberpreviewdialogexample-5",
        security : false
      },
      {
        name: "Preview and Download Part Number Dialog Example #6",
        description : "Preview and Download Part Number Dialog Example #6",
        visible : true,
        id : "preview_download_part_number_dialog_api_example_6",
        url : "/examples/previewdownloadpartnumberdialogexample-6",
        security : false
      },
      {
        name: "IFrame Events Example #7",
        description : "IFrame Events Example #7",
        visible : true,
        id : "iframe_events_api_example_7",
        url : "/examples/iframeeventsexample-7",
        security : false
      }
    ]
  },
  {
    category : "3DX Catalog XML Import",
    id : "xml_import",
    description : "",
    visible : true,
    specs : [
      {
        name: "3DX Catalog XML Import Documentation",
        description : "The documentation link for the 3DX XML Importer",
        visible : true,
        id : "3dx_xml_import_doc",
        url : "/xmlcatalogimport/summary",
        security : false
      },
      {
        name: "3DX Catalog XML Import Template",
        description : "The 3DX catalog import XML template",
        visible : true,
        id : "3dx_xml_import_template",
        url : "/xmlcatalogimport/template",
        security : false
      },
      {
        name: "3DX Catalog XML Import Full Sample",
        description : "A completed 3DX catalog import XML document",
        visible : true,
        id : "3dx_xml_import_full_sample",
        url : "/xmlcatalogimport/sample",
        security : false
      }
    ]
  }
];




// WEBPACK FOOTER //
// ./src/components/CustomApis.js